import React, { Component } from 'react';
import { intlShape, injectIntl } from 'react-intl';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

// eslint-disable-next-line
import style from './_style.css';

class LabelError extends Component {
    render() {
        const { id, message } = this.props;
        const intl = this.props.intl;
        const text = id ? intl.formatMessage({ id }) : message;
        return (
            <Paper className="label_row bg_lipstick" elevation={4}>
                <Typography component="p" className="barlow_regular_message c_white">
                    {text}
                </Typography>
            </Paper>
        );
    }
}

LabelError.propTypes = {
    intl: intlShape.isRequired,
};

LabelError = injectIntl(LabelError);

export default LabelError;



// WEBPACK FOOTER //
// ./src/components/labels/LabelError.js